'use strict';

import { fetchCoachingCompaniesFromServer } from '../persistence/coaching-companies.js'
import { fetchTrainingPlanSessionsFromServer } from '../persistence/training-plans.js'
import { fetchRPESummaryFromServer } from '../persistence/rpe-summary.js'
import { saveTimeBudgetsToServer, fetchCurrentUserTimeBudgetsFromServer, fetchAthleteTimeBudgetsFromServer, toggleTimeBudgetVisibilityOnServer } from '../persistence/time-budget.js'
import { fetchWorkoutSectionsFromServer} from '../persistence/training-sessions.js'
import { batchActions } from 'redux-batched-actions'

// Action types.
export const SET_MOBILE_MODE = 'SET_MOBILE_MODE';
export const CALENDAR_DISPLAY_MODE = 'CALENDAR_DISPLAY_MODE';

export const ATHLETE_ADD = 'ADD_ATHLETE';
export const ATHLETE_SET_CURRENT = 'ATHLETE_SET_CURRENT';
export const ATHLETE_SET_UNSEEN_UPDATES = 'ATHLETE_SET_UNSEEN_UPDATES';
export const REMOVE_ATHLETES = 'REMOVE_ATHLETES';

export const COACHES_RECEIVE = 'COACHES_RECEIVE';

export const GROUP_SET_CURRENT = 'GROUP_SET_CURRENT';
export const RECEIVE_GROUPS = 'RECEIVE_GROUPS';
export const REMOVE_GROUPS = 'REMOVE_GROUPS';

export const TOPIC_MESSAGE_UNSEEN_LIST = 'TOPIC_MESSAGE_UNSEEN_LIST';
export const TOPIC_MARK_SEEN = 'TOPIC_MARK_SEEN';

export const TAG_FILTER_TOGGLE = 'TAG_FILTER_TOGGLE';
export const TAG_FILTER_CLEAR = 'TAG_FILTER_CLEAR';

export const SESSION_SELECTION_OPEN = 'SESSION_SELECTION_OPEN';
export const SESSION_SELECTION_CLEAR = 'SESSION_SELECTION_CLEAR';
export const SESSION_SELECTION_TOGGLE = 'SESSION_SELECTION_TOGGLE';

export const RECEIVE_MARKERS_BY_DATE = 'RECEIEVE_MARKERS_BY_DATE';

export const UPLOADED_FILE_DATA_ADD = 'UPLOADED_FILE_DATA_ADD';
export const UPLOADED_FILE_MARK_IMPORTED = 'UPLOADED_FILE_MARK_IMPORTED';

export const OPEN_NOTE = 'OPEN_NOTE';
export const REQUEST_NOTES = 'REQUEST_NOTES';
export const RECEIVE_NOTES = 'RECEIVE_NOTES';

export const RECEIVE_TABLE_METADATA = 'RECEIVE_TABLE_METADATA';

export const TEMPLATE_TRAINING_SESSIONS_REMOVE = 'TEMPLATE_TRAINING_SESSIONS_REMOVE';

export const RACES_RECEIVE = 'RACES_RECEIVE';

export const ATHLETE_SESSION_FORM_SET_STATE = 'ATHLETE_SESSION_FORM_SET_STATE';


// Action creators.
export const RESET_TO_INITIAL_STATE = 'RESET_TO_INITIAL_STATE'
export function resetToInitialState(time_budget) {
  return { type: RESET_TO_INITIAL_STATE };
}

export const TIME_BUDGET_OPEN_WEEK = 'TIME_BUDGET_OPEN_WEEK';
export function setOpenTimeBudgetWeek(week, year) {
  return { type: TIME_BUDGET_OPEN_WEEK, week: week, year: year};
}

// This probably doesn't need to update the UI. We just assume it worked as a failure is not a big issue and it is deterministic so it getting out of sync will not be an issue either.
export const TIME_BUDGET_TOGGLE_VISIBILITY = 'TIME_BUDGET_TOGGLE_VISIBILITY';
export function timeBudgetToggleVisibility(athlete_id, date, visible) {
  toggleTimeBudgetVisibilityOnServer(athlete_id, date, visible);
  return { type: TIME_BUDGET_TOGGLE_VISIBILITY, athlete_id: athlete_id, visible: visible, date: date };
}

export const TIME_BUDGET_SET_UNSAVED = 'TIME_BUDGET_SET_UNSAVED'
export function setUnsavedTimeBudget(time_budget) {
  return { type: TIME_BUDGET_SET_UNSAVED, time_budget: time_budget };
}

export const TIME_BUDGET_SET_SAVED = 'TIME_BUDGET_SET_SAVED'
function setSavedTimeBudgets(time_budgets, just_saved) {
  return {
    type: TIME_BUDGET_SET_SAVED,
    time_budgets: time_budgets,
    just_saved: just_saved,
  };
}

export const TIME_BUDGET_SET_FOR_ATHLETE = 'TIME_BUDGET_SET_FOR_ATHLETE'
export function setAthleteTimeBudgets(athlete_id, time_budgets) {
  return { type: TIME_BUDGET_SET_FOR_ATHLETE, athlete_id: athlete_id, time_budgets: time_budgets };
}

export const TIME_BUDGET_SET_SAVING = 'TIME_BUDGET_SET_SAVING'
export function saveTimeBudgets(time_budgets, status) {
  if (status == 'saving') {
    return { type: TIME_BUDGET_SET_SAVING, time_budgets: time_budgets, status: status };
  }
  else {
    return (dispatch) => {
      // Run a dispatch to inform the UI that the save operation has started.
      dispatch(saveTimeBudgets(time_budgets, 'saving'))
      // Initiate the save.
      saveTimeBudgetsToServer(time_budgets, (data, status) => {
        dispatch(setSavedTimeBudgets(data, true));
      });
    }
  }
}

export function fetchCurrentUserTimeBudgets() {
  return (dispatch) => {
    fetchCurrentUserTimeBudgetsFromServer((data, status) => { dispatch(setSavedTimeBudgets(data, false)) });
  }
}

export function fetchAthleteTimeBudgets(athlete_id) {
  return (dispatch) => {
    fetchAthleteTimeBudgetsFromServer(athlete_id, (data, status) => { dispatch(setAthleteTimeBudgets(athlete_id, data)) });
  }
}

export function setMobileMode(mobile_mode) {
  return { type: SET_MOBILE_MODE, mobile_mode: mobile_mode };
}

export const SET_PAGE_CONTEXT = 'SET_PAGE_CONTEXT';
export function setPageContext(context) {
  return { type: SET_PAGE_CONTEXT, context };
}

export function athlete_set_unseen_updates(athlete_id, unseen_count, oldest_url) {
  return { type: ATHLETE_SET_UNSEEN_UPDATES, athlete_id: athlete_id, unseen_count: unseen_count, oldest_url: oldest_url };
}

export function set_current_athlete(athlete_id) {
  return { type: ATHLETE_SET_CURRENT, athlete_id: athlete_id };
}

export function athlete_add(athlete_data) {
  return { type: ATHLETE_ADD, athlete_data: athlete_data};
}

export const RECEIVE_ATHLETES = 'RECEIVE_ATHLETES';
export function athleteReceive(athletes) {
  return { type: RECEIVE_ATHLETES, athletes: athletes};
}

export function athleteRemove(athlete_ids) {
  return { type: REMOVE_ATHLETES, athlete_ids: athlete_ids};
}

export function coachesReceive(coaches) {
  return { type: COACHES_RECEIVE, coaches: coaches};
}

export function set_current_group(group_id) {
  return { type: GROUP_SET_CURRENT, group_id: group_id };
}

export function groupReceive(groups) {
  return { type: RECEIVE_GROUPS, groups: groups};
}

export function groupRemove(group_ids) {
  return { type: REMOVE_GROUPS, group_ids: group_ids};
}

export function updateTopicMessagesUnseenList(topic_ids, group_ids) {
  return { type: TOPIC_MESSAGE_UNSEEN_LIST, topic_ids: topic_ids, group_ids: group_ids};
}

export function markTopicSeen(topic_id, group_id) {
  return { type: TOPIC_MARK_SEEN, topic_id: topic_id, group_id: group_id};
}

export function toggle_tag_filter(tag_name) {
  return { type: TAG_FILTER_TOGGLE, tag_name: tag_name};
}

export function clear_tag_filter() {
  return { type: TAG_FILTER_CLEAR };
}

/**
 * mode is one of 'calendar' or 'list'.
 */
export function setCalendarDisplayMode(mode) {
  return { type: CALENDAR_DISPLAY_MODE, mode: mode }
}

export function toggle_session_selection(session_id) {
  return { type: SESSION_SELECTION_TOGGLE, session_id: session_id};
}

export function open_session_selection(collection) {
  return { type: SESSION_SELECTION_OPEN, collection: collection};
}

export function clear_session_selection(collection) {
  return { type: SESSION_SELECTION_CLEAR };
}

export function add_uploaded_file_data(uploaded_file_data) {
  return { type: UPLOADED_FILE_DATA_ADD, uploaded_file_data: uploaded_file_data};
}

export function mark_uploaded_files_imported(uploaded_file_ids) {
  return { type: UPLOADED_FILE_MARK_IMPORTED, uploaded_file_ids: uploaded_file_ids};
}

export function markersByDateReceive(markers_by_date) {
  return { type: RECEIVE_MARKERS_BY_DATE, calendar_markers_by_date: markers_by_date};
}

export function noteLoadSummaries(note_id) {
  return { type: OPEN_NOTE, note_id: note_id }
}

export function noteRequest(note_id) {
  return { type: REQUEST_NOTES, note_id: note_id }
}

export function noteReceive(notes) {
  return { type: RECEIVE_NOTES, notes: notes }
}

export const PRIVATE_MESSAGE_CONVERSATION_DATA = 'PRIVATE_MESSAGE_CONVERSATION_DATA';
export function setPrivateMessageConversationData(conversation_details) {
  return { type: PRIVATE_MESSAGE_CONVERSATION_DATA, conversation_details: conversation_details}
}

export const PRIVATE_MESSAGE_MULTI_CONVERSATION_DATA = 'PRIVATE_MESSAGE_MULTI_CONVERSATION_DATA';
export function setMultiPrivateMessageConversationData(messages) {
  return { type: PRIVATE_MESSAGE_MULTI_CONVERSATION_DATA, messages: messages}
}

export const PRIVATE_MESSAGE_UPDATE_UNSEEN = 'PRIVATE_MESSAGE_UPDATE_UNSEEN';
export function privateMessageUpdateUnseen(recipient_id, unseen_count) {
  return { type: PRIVATE_MESSAGE_UPDATE_UNSEEN, recipient_id: recipient_id, unseen_count: unseen_count}
}

export function tableMetadataReceive(table_metadata) {
  return { type: RECEIVE_TABLE_METADATA, table_metadata: table_metadata }
}

export const TRAINING_SESSION_OPEN = 'TRAINING_SESSION_OPEN';
export function trainingSessionOpen(training_session_uuid) {
  return { type: TRAINING_SESSION_OPEN, training_session_id: training_session_uuid };
}

export const TRAINING_SESSIONS_UNSAVED_RECEIVE = 'TRAINING_SESSIONS_UNSAVED_RECEIVE';
export function trainingSessionsUnsavedReceive(training_sessions) {
  return { type: TRAINING_SESSIONS_UNSAVED_RECEIVE, training_sessions: training_sessions };
}

export const TRAINING_SESSIONS_RECEIVE = 'TRAINING_SESSIONS_RECEIVE';
export function trainingSessionsReceive(training_sessions) {
  return { type: TRAINING_SESSIONS_RECEIVE, training_sessions: training_sessions };
}

export const TRAINING_SESSIONS_REMOVE = 'TRAINING_SESSIONS_REMOVE';
export function trainingSessionsRemove(training_session_uuids) {
  return { type: TRAINING_SESSIONS_REMOVE, training_session_uuids: training_session_uuids };
}

export const TEMPLATE_TRAINING_SESSIONS_RECEIVE = 'TEMPLATE_TRAINING_SESSIONS_RECEIVE';
export function templateTrainingSessionsReceive(template_training_sessions, template_folders, training_plans) {
  return {
    type: TEMPLATE_TRAINING_SESSIONS_RECEIVE,
    template_training_sessions: template_training_sessions,
    template_folders: template_folders,
    training_plans: training_plans,
  };
}

export function templateTrainingSessionsRemove(template_training_session_ids, template_folder_ids) {
  return {
    type: TEMPLATE_TRAINING_SESSIONS_REMOVE,
    template_training_session_ids: template_training_session_ids,
    template_folder_ids: template_folder_ids,
  };
}

export const TEMPLATE_TRAINING_SESSIONS_REMOVE_ALL = 'TEMPLATE_TRAINING_SESSIONS_REMOVE_ALL';
export function templateTrainingSessionsRemoveAll() {
  return { type: TEMPLATE_TRAINING_SESSIONS_REMOVE_ALL };
}

export const ACTIVITY_PLANS_RECEIVE = 'ACTIVITY_PLANS';
export function receiveActivityPlans(activity_plans) {
  return { type: ACTIVITY_PLANS_RECEIVE, activity_plans: activity_plans};
}

export function racesReceive(races) {
  // NOTE This is not yet implemented in the store so this should be treated as stub code.
  return { type: RACES_RECEIVE, races: races};
}

export const RACES_REMOVE = 'RACES_REMOVE';
export function racesRemove(race_uuids) {
  // NOTE This is not yet implemented in the store so this should be treated as stub code.
  return { type: RACES_REMOVE, race_uuids: race_uuids};
}

export const CALENDAR_NOTES_RECEIVE = 'CALENDAR_NOTES_RECEIVE';
export function calendarNotesReceive(calendar_notes) {
  return { type: CALENDAR_NOTES_RECEIVE, calendar_notes: calendar_notes};
}

export function fetchTrainingPlanSessions(training_plan_id) {
  return function (dispatch) {

    // Mark the training plan session data as loading so we know not to try
    // loading again.
    dispatch(receiveTrainingPlan({
      id: training_plan_id,
      sessions_loading_state: 'loading',
    }));

    // Fetch the data.
    fetchTrainingPlanSessionsFromServer(training_plan_id, (data, status) => {

      data.training_plan.sessions_loading_state = 'loaded';

      dispatch(batchActions([
        receiveTrainingPlan(data.training_plan),
        racesReceive(data.races),
        trainingSessionsReceive(data.sessions),
        receiveActivityPlans(data.activity_plans),
      ]))

    });

  }
}

export const TRAINING_PLAN_RECEIVE = 'TRAINING_PLAN_RECEIVE';
export function receiveTrainingPlan(training_plan) {
  return { type: TRAINING_PLAN_RECEIVE, training_plan: training_plan };
}

export const TRAINING_PLAN_DELETE_FROM_STORE = 'TRAINING_PLAN_DELETE_FROM_STORE'
export function deleteTrainingPlanFromStore(training_plan_id) {
  return { type: TRAINING_PLAN_DELETE_FROM_STORE, training_plan_id: training_plan_id };
}

export const TRAINING_PLAN_SET_DRAG_STATE = 'TRAINING_PLAN_SET_DRAG_STATE'
export function setTrainingPlanDragState(state, start_date_or_day) {
  return { type: TRAINING_PLAN_SET_DRAG_STATE, state: state, start_date_or_day: start_date_or_day };
}

export const TRAINING_PLAN_COPY_JUST_ADDED = 'TRAINING_PLAN_COPY_JUST_ADDED';
export function recordLastCopiedTrainingPlan(training_sessions, races, training_plan_copy_id, activity_plans) {
  return function (dispatch) {
    dispatch(batchActions([
      trainingSessionsReceive(training_sessions),
      racesReceive(races),
      receiveActivityPlans(activity_plans),
      ({
        type: TRAINING_PLAN_COPY_JUST_ADDED,
        training_sessions: training_sessions,
        races: races,
        training_plan_copy_id: training_plan_copy_id,
      })
    ]))
  }
}

export const TRAINING_PLAN_COPY_DELETE_FROM_STORE = 'TRAINING_PLAN_COPY_DELETE_FROM_STORE';
export function deleteLastCopiedTrainingPlanFromStore(training_session_uuids, race_uuids, training_plan_copy_id) {
  return function (dispatch) {
    dispatch(trainingSessionsRemove(training_session_uuids));
    dispatch(racesRemove(race_uuids));
    dispatch({
      type: TRAINING_PLAN_COPY_DELETE_FROM_STORE,
      training_plan_copy_id: training_plan_copy_id,
    });
  }
}

export const CONTENT_ATTACHMENTS_RECEIVE = 'CONTENT_ATTACHMENTS_RECEIVE'
export function contentAttachmentsReceive(content_attachments, upload_MB_current, upload_MB_limit, uploading_granted) {
  return {
    type: CONTENT_ATTACHMENTS_RECEIVE,
    content_attachments: content_attachments,
    upload_MB_current: upload_MB_current,
    upload_MB_limit: upload_MB_limit,
    uploading_granted: uploading_granted,
  };
}

export function fetchCoachingCompanies(coaching_companies) {
  return (dispatch) => {
    fetchCoachingCompaniesFromServer((data, status) => {
      dispatch(receiveCoachingCompanies(data.coaching_companies))
    });
  }
}

export const COACHING_COMPANIES_RECEIVE = 'COACHING_COMPANIES_RECEIVE';
export function receiveCoachingCompanies(coaching_companies) {
  return { type: COACHING_COMPANIES_RECEIVE, coaching_companies: coaching_companies};
}

export const TIME_IN_ZONES_RECEIVE = 'TIME IN ZONES RECEIVE';
export function setTimeInZones(time_in_zones) {
  return { type: TIME_IN_ZONES_RECEIVE, time_in_zones: time_in_zones };
}

export function fetchRPESummary(athlete_id, start_date, end_date) {
  return (dispatch) => {
    fetchRPESummaryFromServer(athlete_id, start_date, end_date, (data, status) => {
      dispatch(batchActions([
        receiveRPESummary(athlete_id, data.rpe_summary),
        receiveRPEThresholds(athlete_id, data.rpe_thresholds),
        racesReceive(data.races),
        calendarNotesReceive(data.calendar_notes),
        receiveMySasyData(athlete_id, data.mysasy_measurements),
      ]));
    });
  }
}

export const MYSASY_MEASUREMENTS_RECEIVE = 'MYSASY_MEASUREMENTS_RECEIVE';
export function receiveMySasyData(athlete_id, mysasy_measurements) {
  return {
    type: MYSASY_MEASUREMENTS_RECEIVE,
    athlete_id: athlete_id,
    mysasy_measurements: mysasy_measurements,
  };
}

export const RPE_SUMMARY_RECEIVE = 'RPE_SUMMARY_RECEIVE';
export function receiveRPESummary(athlete_id, rpe_summary) {
  return {
    type: RPE_SUMMARY_RECEIVE,
    athlete_id: athlete_id,
    rpe_summary: rpe_summary,
  };
}

export const RPE_THRESHOLDS_RECEIVE = 'RPE_THRESHOLDS_RECEIVE';
export function receiveRPEThresholds(athlete_id, rpe_thresholds) {
  return {
    type: RPE_THRESHOLDS_RECEIVE,
    athlete_id: athlete_id,
    rpe_thresholds: rpe_thresholds,
  };
}

export const RPE_CURRENT_STATUS_RECEIVE = 'RPE_CURRENT_STATUS_RECEIVE';
export function receiveRPECurrentStatus(athlete_id, chronic_status, acute_status) {
  return {
    type: RPE_CURRENT_STATUS_RECEIVE,
    athlete_id: athlete_id,
    chronic_status: chronic_status,
    acute_status: acute_status,
  };
}

export function fetchWorkoutSections() {
  return (dispatch) => {
    fetchWorkoutSectionsFromServer((data, status) => { dispatch(setWorkoutSections(data.workout_sections)) });
  }
}

export const WORKOUT_SECTIONS_SET = 'WORKOUT_SECTIONS_SET';
export function setWorkoutSections(workout_sections) {
  return { type: WORKOUT_SECTIONS_SET, workout_sections: workout_sections};
}
